import DefaultInstance from "@/instance/axios";
import { createMutationKeys, createQueryKeys, mergeQueryKeys } from "@lukemorales/query-key-factory";
import { DefaultApiAbstractItemsAbstractItemIdDeleteRequest, DefaultApiAbstractItemsAbstractItemIdPutRequest, DefaultApiAbstractItemsFindPostRequest, DefaultApiAbstractItemsGetRequest, DefaultApiAbstractItemsPostRequest } from "@sizlcorp/sizl-api-document/dist/models";

export const abstractltems = createQueryKeys('abstractItems', {
    all : null,
    get : (params: DefaultApiAbstractItemsGetRequest) => {
        const query = { ...params };
        if (Array.isArray(params.query.$and) && params.query.$and.length > 0) {
            query["query"] = JSON.stringify(params.query);
        }
        if (params.search) {
            query["search"] = params.search;
            query["searchFields"] = params.searchFields;
        }
        return {
            queryKey : [query, JSON.stringify(query.query)],
            queryFn : () => DefaultInstance.abstractItemsGet(query)
        }
    },
    find : (params: DefaultApiAbstractItemsFindPostRequest) => {
        const query = { ...params };
        if (Array.isArray(params.query.$and) && params.query.$and.length > 0) {
            query["query"] = JSON.stringify(params.query);
        }
        if (params.search) {
            query["search"] = params.search;
            query["searchFields"] = params.searchFields;
        }
        return {
            queryKey : [query, JSON.stringify(query.query)],
            queryFn : () => DefaultInstance.abstractItemsFindPost(query)
        }
    },
});

export const mutateAbstractltems = createMutationKeys('abstractItems', {
    create : (params : DefaultApiAbstractItemsPostRequest) => ({
        mutationKey : [params.abstractItemsGetRequest],
        mutationFn : () => DefaultInstance.abstractItemsPost(params),
    }),
    update : (params : DefaultApiAbstractItemsAbstractItemIdPutRequest) => ({
        mutationKey : [params.abstractItemId, params.abstractItemsGetRequest],
        mutationFn : () => DefaultInstance.abstractItemsAbstractItemIdPut(params)
    }),
    delete : (params : DefaultApiAbstractItemsAbstractItemIdDeleteRequest) => ({
        mutationKey : [params.abstractItemId],
        mutationFn : () => DefaultInstance.abstractItemsAbstractItemIdDelete(params)
    }),
});

export const abstractItemsQueryKeys = mergeQueryKeys(abstractltems, mutateAbstractltems);